/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tool_Risk_Elevated_HintInputs */



/**
* | output |
* | --- |
* | "Changes data. Confirmed by default, and you can grant it a time-limited trust window." |
*
* @param {Tool_Risk_Elevated_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tool_risk_elevated_hint = /** @type {((inputs?: Tool_Risk_Elevated_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tool_Risk_Elevated_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verändert Daten. Wird standardmäßig bestätigt, und Sie können ein zeitlich begrenztes Vertrauensfenster gewähren.")
	return /** @type {LocalizedString} */ ("Changes data. Confirmed by default, and you can grant it a time-limited trust window.")
});